import styled from 'styled-components'

export const WrapInputDate = styled.div `
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 38px;
    margin-left: 1px;
    flex-grow: 1;
    margin-right: 1px;
    margin-bottom: 10px;
    box-sizing: border-box;
    padding: 0 5px;
    @media (max-width: 800px){
        width: 60%;
        margin: 0;
        padding: 0
    }
`;

// --- específico do relatório AFD: exibição de inconsistências em lote ---

export const ErrorBox = styled.div `
    margin: 16px 20px;
    padding: 12px 16px;
    border: 1px solid #e0a1a1;
    border-radius: 4px;
    background-color: #fdecea;
`;

export const ErrorBoxTitle = styled.h4 `
    color: #a13333;
    margin: 0 0 10px 0;
`;

export const ErrorTable = styled.table `
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;

    th, td {
        text-align: left;
        padding: 6px 10px;
        border-bottom: 1px solid #e0c0c0;
    }

    th {
        color: #a13333;
        font-weight: 600;
    }
`;